module.exports = __webpack_public_path__ + "img/1557614098400747521.b59114a2.png";